import { TooltipProps } from '@yandex-lego/components/Tooltip/desktop/bundle';

import { PALETTE_ORIENTATION } from './types';

export function getTooltipDirection(orientation: PALETTE_ORIENTATION): TooltipProps['direction'] {
    if (orientation === PALETTE_ORIENTATION.VERTICAL) {
        return 'right';
    }

    if (orientation === PALETTE_ORIENTATION.VERTICAL_RIGHT) {
        return 'left';
    }

    return 'top';
}
